import { render } from "./NavBar.vue?vue&type=template&id=586cf3ce"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
script.render = render

export default script